export enum ResettableInputType {
  TEXT,
  SELECT
}
